<template>
  <div>
    <div class="btn-wrapper">
      <div class="ml-2">
        <create-dependencia
          :dependencias="dependencias"
          @dependencia-criada="() => this.refetchCSU()"
          v-if="isDev"
        />
      </div>
      <v-btn
        @click="deleteSelected"
        color="red"
        variant="plain"
        size="x-small"
        v-if="isDev"
        :append-icon="!this.isLoading ? 'mdi-delete-outline' : ''"
        >Excluir Selecionado
        <v-progress-circular
          v-if="this.isLoading"
          class="ml-2"
          indeterminate
          size="20"
      /></v-btn>
    </div>

    <div ref="network" id="network"></div>
  </div>
</template>

<script>
import axios from 'axios';
import { Network, DataInterfaceNodes } from 'vis-network';
import vis from 'vis-network/dist/vis-network.min.js';

import CreateDependencia from '@/components/dialogs/CreateDependencia.vue';
import store from '@/store/store';

export default {
  name: 'GraphNetwork',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    id: Number,
    // eslint-disable-next-line vue/require-default-prop
    dependencias: null,
    isCsu: { type: Boolean, default: true },
    refetchCSU: Function,
  },
  data() {
    return {
      data: null,
      nodes: null,
      edges: null,
      container: null,
      isLoading: false,
      network: { type: DataInterfaceNodes },
      options: {},
      selectedNodeId: null,
    };
  },
  mounted() {
    this.drawGraph();
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  watch: {
    dependencias(newDep, oldDep) {
      // Se não for a primeira vez que o componente é carregado
      if (oldDep !== null) {
        this.drawGraph();
      }
    },
  },
  methods: {
    async deleteSelected() {
      if (this.selectedNodeId !== null) {
        if (this.selectedNodeId != this.id) {
          const csu = this.nodes.get(this.selectedNodeId).from;
          const efe = this.nodes.get(this.selectedNodeId).to;
          const apiUrl = process.env.VUE_APP_API_URL || 'http://localhost:3000';
          this.isLoading = true;
          try {
            const result = await axios.post(
              apiUrl + '/api/v1/productBacklog/deleteDep',
              {
                // eslint-disable-next-line camelcase
                id_caso_de_uso: parseInt(csu),
                // eslint-disable-next-line camelcase
                id_dependencia_eferente: parseInt(efe),
              },
              {
                headers: {
                  Authorization: `Bearer ${store.state.token}`,
                },
              },
            );

            this.isLoading = false;
            this.nodes.remove(this.selectedNodeId);
            this.refetchCSU();
            this.selectedNodeId = null;
            console.log(result);
          } catch (error) {
            console.log(error);
            this.isLoading = false;
          }
        }
      }
    },
    handleKeyDown(event) {
      if (event.key === 'Backspace') {
        this.deleteSelected();
      }
    },
    drawGraph() {
      this.nodes = [];
      this.edges = [];
      // this.dependencias.forEach((item, index) => {
      //   if (this.id === item.id_caso_de_uso) {
      //     this.nodes = [
      //       ...this.nodes,
      //       {
      //         id: item.id_dependencia_eferente,
      //         label: item.dep_nome,
      //         physics: false,
      //         from: item.id_caso_de_uso,
      //         to: item.id_dependencia_eferente,
      //       },
      //     ];
      //     if (index === 0) {
      //       this.nodes = [
      //         ...this.nodes,
      //         {
      //           id: item.id_caso_de_uso,
      //           label: item.csu_nome,
      //           fixed: {
      //             y: true,
      //             x: true,
      //           },
      //           from: item.id_caso_de_uso,
      //           to: item.id_dependencia_eferente,
      //         },
      //       ];
      //     }
      //   } else {
      //     this.nodes = [
      //       ...this.nodes,
      //       {
      //         id: item.id_caso_de_uso,
      //         label: item.csu_nome,
      //         physics: false,
      //         from: item.id_caso_de_uso,
      //         to: item.id_dependencia_eferente,
      //       },
      //     ];
      //     if (index === 0) {
      //       this.nodes = [
      //         ...this.nodes,
      //         {
      //           id: item.id_dependencia_eferente,
      //           label: item.dep_nome,
      //           fixed: {
      //             y: true,
      //             x: true,
      //           },
      //           from: item.id_caso_de_uso,
      //           to: item.id_dependencia_eferente,
      //         },
      //       ];
      //     }
      //   }
      //   this.edges = [
      //     ...this.edges,
      //     {
      //       from: item.id_caso_de_uso,
      //       to: item.id_dependencia_eferente,
      //       label: item.tipo_dependencia.toLowerCase(),
      //       dashes:
      //         item.tipo_dependencia.toLowerCase() == 'include' ||
      //         item.tipo_dependencia.toLowerCase() == 'extend',
      //       arrows: {
      //         to: {
      //           enabled: true,
      //           type:
      //             item.tipo_dependencia.toLowerCase() == 'include' ||
      //             item.tipo_dependencia.toLowerCase() == 'extend'
      //               ? 'vee'
      //               : 'arrow',
      //         },
      //       },
      //     },
      //   ];
      // });
      // console.log(this.dependencias);
      // console.log(this.nodes);
      // console.log(this.edges);
      this.dependencias.forEach((item) => {
        this.nodes = [
          ...this.nodes,
          {
            id: item.id_caso_de_uso,
            label: item.csu_nome,
            physics: false,
            from: item.id_caso_de_uso,
            to: item.id_dependencia_eferente,
          },
          {
            id: item.id_dependencia_eferente,
            label: item.dep_nome,
            physics: false,
            from: item.id_caso_de_uso,
            to: item.id_dependencia_eferente,
          },
        ];

        this.edges = [
          ...this.edges,
          {
            from: item.id_caso_de_uso,
            to: item.id_dependencia_eferente,
            label: item.tipo_dependencia.toLowerCase(),
            dashes:
              item.tipo_dependencia.toLowerCase() == 'include' ||
              item.tipo_dependencia.toLowerCase() == 'extend',
            arrows: {
              to: {
                enabled: true,
                type:
                  item.tipo_dependencia.toLowerCase() == 'include' ||
                  item.tipo_dependencia.toLowerCase() == 'extend'
                    ? 'vee'
                    : 'arrow',
              },
            },
          },
        ];
      });
      console.log(this.nodes, 'nodes');

      // Melhorar estrategia
      let size = this.nodes.filter(
        (item) => item.id === this.$route.params.id,
      ).length;
      const isRepeated = size > 1;
      // console.log(isRepeated);
      while (size > 1) {
        if (isRepeated) {
          const index = this.nodes
            .map((item) => item.id)
            .indexOf(this.$route.params.id);
          if (index > -1) {
            this.nodes.splice(index, 1);
          }
        }
        size--;
      }
      // console.log(this.nodes, 'pre');
      this.nodes = this.nodes.filter((item) => {
        if (item.id.toString() !== this.$route.params.id.toString()) {
          if (item.to === this.$route.params.id.toString()) {
            return false;
          }
        }

        return true;
      });
      // console.log(this.nodes, 'pos');
      this.nodes = new vis.DataSet(this.nodes);
      this.edges = new vis.DataSet(this.edges);
      this.container = document.getElementById('network');
      this.data = {
        nodes: this.nodes,
        edges: this.edges,
      };
      this.options = {};
      // eslint-disable-next-line no-unused-vars
      const network = new Network(this.container, this.data, this.options);
      network.on('selectNode', (event) => {
        this.selectedNodeId = event.nodes[0];
      });
    },
  },
  computed: {
    isDev() {
      return localStorage.getItem('formaAtuacao') === '"DESENVOLVEDOR"';
    },
  },
  components: { CreateDependencia },
};
</script>

<style scoped>
#network {
  width: calc(100% - 2rem);
  height: 400px;
  margin: 1rem;
  border-radius: 5px;
  border: 1px solid lightgray;
}
.btn-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
